<template>
  <div>
    <PageAllow controller="AccountLogs" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherQueueDataTypes v-model="options.types"/>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :items="$consts.queueDataStatus"
                    :label="$t('queueDataLogs.Fields.status')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="queue_datas"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | queueDataStatusColor"
              :text-color="item.status | queueDataStatusTextColor"
            >
              {{ item.status | queueDataStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.data="{ item }">
            <v-btn
              @click.stop="
                Dialog = true;
                dataItem = item.data;
              "
            >
              {{ $t("AccountLogs.data") }}
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  v-if="item.actions && item.actions.re_push"
                  @click="confirmDialog = true;
                    currentItem = item
                  "
                >
                  {{ $t("queueDataLogs.rePush") }}
                </v-btn>
              </template>
              <span>{{ $t("queueDataLogs.rePush") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="Dialog" width="600px">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text v-model="dataItem">
          <JsonViewer
            :value="dataItem"
            expanded
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 配送前校验运费是否已录入 -->
    <DialogAlert
      v-model="confirmDialog"
      :message="$t('queueDataLogs.isRePush')"
      persistent
      useConfirm
      @confirm="rePush(currentItem)"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherQueueDataTypes from "@/components/plugins/SearcherQueueDataTypes";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import DialogAlert from "@/components/plugins/DialogAlert";
import Logs from "@/api/logs";
import i18n from "@/i18n";
import JsonViewer from 'vue-json-viewer'


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  type: 0,
  status: [0,1,2]
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("queue-data-logs-options")
        ? sessionStorage.getItem("queue-data-logs-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    func: "",
    param:"",
    queue_datas: [],
    paging: {},
    Dialog: false,
    dataItem: null,
    confirmDialog: false,
    currentItem: null
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.accountLogs"),
        disabled: false,
        href: "/settings/queue-data-logs",
      },
      {
        text: i18n.t("SettingNav.queueDataLogs"),
        disabled: true,
        href: "/settings/queue-data-logs",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("queueDataLogs.date"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("queueDataLogs.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("queueDataLogs.Fields.push_platform"),
        align: "start",
        sortable: false,
        value: "push_platform",
      },
      {
        text: i18n.t("queueDataLogs.Fields.type"),
        align: "center",
        sortable: false,
        value: "type_name",
      },
      {
        text: i18n.t("queueDataLogs.Fields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("queueDataLogs.Fields.error_msg"),
        align: "center",
        sortable: false,
        value: "error_msg",
      },
      {
        text: i18n.t("queueDataLogs.Fields.retry"),
        align: "center",
        sortable: false,
        value: "retry",
      },
      {
        text: i18n.t("queueDataLogs.Fields.data"),
        align: "center",
        sortable: false,
        value: "data",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "center",
        sortable: false,
        value: "actions",
      }
    ],
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherQueueDataTypes,
    SearcherStatus,
    DialogAlert,
    JsonViewer,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        func: this.func,
        param: this.param
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getLogsFromAPI() {
      this.loading = true;
      Logs.fetchQueueDataLogs(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.queue_datas = response.data.queue_datas;

            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    rePush(item) {
      this.$store.dispatch("fullscreenLoading");
      Logs.queueDataRePush(item.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("queueDataLogs.pushSuccess"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
      this.$store.dispatch("fullscreenLoadingStop");
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("queue-data-logs-options", JSON.stringify(this.options));
        this.getLogsFromAPI();
      },
    },
    
  },
};
</script>

<style>
</style>